import { Fragment } from "react";
import NetworkIcon from "../../../icons/networkIcon";
import TermCard from "./termCard";
import { useTranslation } from "react-i18next";

const InternationalTrade = () => {
  const { t } = useTranslation();
  const terms = [
    { img: "/assets/EXW.png", name: "exWorks", cost: "exWorksCost", risks: "exWorksRisk" },
    { img: "/assets/FOB.png", name: "FOB", cost: "FOBCost", risks: "FOBRisk" },
    { img: "/assets/CIF.png", name: "CIF", cost: "CIFCost", risks: "CIFRisk", insurance: true },
    { img: "/assets/FCA.png", name: "FCA", cost: "FCACost", risks: "FCARisk" },
    { img: "/assets/CPT.png", name: "CPT", cost: "CPTCost", risks: "CPTRisk" },
    { img: "/assets/CIP.png", name: "CIP", cost: "CIPCost", risks: "CIPRisk", insurance: true },
    { img: "/assets/DAP.png", name: "DAP", cost: "DAPCost", risks: "DAPRisk", insurance: true },
    { img: "/assets/DPU.png", name: "DPU", cost: "DPUCost", risks: "DPURisk", insurance: true },
    { img: "/assets/DDP.png", name: "DDP", cost: "DDPCost", risks: "DDPRisk", insurance: true },
    { img: "/assets/FAS.png", name: "FAS", cost: "FASCost", risks: "FASRisk", insurance: true },
    { img: "/assets/CFR.png", name: "CFR", cost: "CFRCost", risks: "CFRRisk", insurance: true },
  ];

  return (
    <main className="min-h-screen bg-gray-50/50">
      <article className="py-10 md:py-20">
        {/* max-w-5xl أو max-w-6xl تعطي عرضاً ممتازاً ومتناسقاً على الشاشات الكبيرة جداً */}
        <div className="w-11/12 max-w-6xl mx-auto">
          
          {/* Icon Section */}
          <span className="flex justify-center mb-4">
            <NetworkIcon fill="#0051FF" className="w-[50px] h-[50px] md:w-[60px] md:h-[60px]" />
          </span>

          {/* Heading */}
          <h1 className="text-2xl md:text-4xl font-bold text-mainBlue text-center mb-10 tracking-tight">
            {t("incoterms")}
          </h1>

          {/* الكروت ستعرض بعرض الشاشة بالكامل في كل الأحجام */}
          <section className="grid grid-cols-1 gap-8">
            {terms.map((term, i) => (
              <Fragment key={i}>
                <TermCard term={term} />
              </Fragment>
            ))}
          </section>

        </div>
      </article>
    </main>
  );
};

export default InternationalTrade;